import { useInView } from 'react-intersection-observer';
import { Box, Fade, Slide, Zoom } from '@mui/material';

export function Reveal({ children, animation = 'fade', delay = 300 }) {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

    const transition = { transitionDelay: `${delay}ms` };

    switch (animation) {
        case 'zoom':
            return (
                <Box ref={ref}>
                    <Zoom in={inView} timeout={delay} style={transition}>
                        <Box>{children}</Box>
                    </Zoom>
                </Box>
            );
        case 'slide-right':
            return (
                <Box ref={ref}>
                    <Slide direction="right" in={inView} timeout={delay}>
                        <Box>{children}</Box>
                    </Slide>
                </Box>
            );
        case 'slide-left':
            return (
                <Box ref={ref}>
                    <Slide direction="left" in={inView} timeout={delay}>
                        <Box>{children}</Box>
                    </Slide>
                </Box>
            );
        case 'slide-up':
            return (
                <Box ref={ref}>
                    <Slide direction="up" in={inView} timeout={delay}>
                        <Box>{children}</Box>
                    </Slide>
                </Box>
            );
        case 'fade':
        default:
            return (
                <Box ref={ref}>
                    <Fade in={inView} timeout={delay} style={transition}>
                        <Box>{children}</Box>
                    </Fade>
                </Box>
            );
    }
}
